import styled from '@emotion/styled'
import UploadcareImage from '@uploadcare/nextjs-loader'

import GradientOverlay from './GradientOverlay'

const Container = styled(GradientOverlay)`
  border-radius: 0.25rem;
  margin-bottom: ${({ theme }) => theme.space[3]};
  width: 100%;
`

const HeroImage = ({ className, src }) => (
  <Container className={className}>
    <UploadcareImage
      alt="list image"
      height={400}
      layout="responsive"
      priority
      src={src + '.jpg'}
      width={800}
    />
  </Container>
)

export default HeroImage
